import e, { useState as r } from "react";
import t from "../../../../../node_modules/classnames/index.js";
import { CollapsibleBoxOnClick as n } from "./CollapsibleBoxOnClick.js";
import { Icon as a } from "../../../general/Icon/Icon.js";
import { OptionButton as l } from "../../../buttons/OptionButton/OptionButton.js";
function o(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function i(r) {
  var t = r.open,
    n = r.title;
  return e.createElement("div", {
    className: "toggle-header"
  }, e.createElement("span", {
    className: "toggle-ellipsis"
  }, e.createElement(a, {
    name: "ellipsis-h",
    regular: !0
  })), e.createElement("span", {
    className: "toggle-title"
  }, n), t ? e.createElement(a, {
    name: "angle-down",
    regular: !0,
    className: "toggle-header__toggle-icon"
  }) : e.createElement(a, {
    name: "angle-up",
    regular: !0,
    className: "toggle-header__toggle-icon"
  }));
}
var c = function c(_c) {
  var s,
    m = _c.onCollapse,
    u = _c.onExpand,
    f = function (e) {
      if (Array.isArray(e)) return e;
    }(s = r(!1)) || function (e, r) {
      var t,
        n,
        a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != a) {
        var l = [],
          o = !0,
          i = !1;
        try {
          for (a = a.call(e); !(o = (t = a.next()).done) && (l.push(t.value), !r || l.length !== r); o = !0);
        } catch (e) {
          i = !0, n = e;
        } finally {
          try {
            o || null == a.return || a.return();
          } finally {
            if (i) throw n;
          }
        }
        return l;
      }
    }(s, 2) || function (e, r) {
      if (e) {
        if ("string" == typeof e) return o(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        if ("Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t) return Array.from(t);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return o(e, r);
      }
    }(s, 2) || function () {
      throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }(),
    p = f[0],
    g = f[1],
    d = e.createElement(i, {
      open: p,
      title: _c.title
    }),
    y = e.createElement("div", {
      className: "sidebar-drawer-opaque-box"
    });
  return e.createElement("div", null, e.createElement(n, {
    className: t("drawer-container", _c.className),
    open: p,
    onHeaderClick: function onHeaderClick() {
      p ? null == u || u() : null == m || m(), g(!p);
    },
    header: d
  }, y, _c.itemsDrawer), e.createElement(l, {
    label: e.createElement(a, {
      name: "ellipsis-h",
      regular: !0
    }),
    arrowSize: 0,
    edgeOffset: 0,
    closeOnClickInside: !0
  }, _c.itemsDrawer));
};
export { c as SidebarDrawer };